import { useEffect, useRef } from 'react';
import '../Styles/counter.css'

function Counter({num1, num2, num3}) {
    const counterRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    counterRef.current.classList.add('animate');
                } else {
                    counterRef.current.classList.remove('animate');
                }
            },
            { threshold: 0.5 } 
        );

        if (counterRef.current) {
            observer.observe(counterRef.current);
        }

        return () => {
            if (counterRef.current) {
                observer.unobserve(counterRef.current);
            }
        };
    }, []);
  return (
    <div id="counter" ref={counterRef}>
        <ul className="digits digits-first">
            <li>0</li>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>0</li>
            <li>5</li>
            <li>6</li>
            <li>{num1}</li>
            <li>8</li>
            <li>9</li>
        </ul>
        <ul className="digits digits-second">
            <li>0</li>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
            <li>{num2}</li>
            <li>8</li>
            <li>9</li>
        </ul>
        <ul className="digits digits-first">
            <li>0</li>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>0</li>
            <li>5</li>
            <li>6</li>
            <li>{num3}</li>
            <li>8</li>
            <li>9</li>
        </ul>
    </div>
  )
}

export default Counter
